import { render, staticRenderFns } from "./Register-applicant-education.vue?vue&type=template&id=a7898f6c&scoped=true&"
import script from "./Register-applicant-education.vue?vue&type=script&lang=js&"
export * from "./Register-applicant-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7898f6c",
  null
  
)

export default component.exports